import * as React from "react";
import { Table, Button } from "react-bootstrap";
import { firestore } from "firebase";
import * as fs from "../firestore";
import moment from "moment";

export type Warranty = fs.Warranty & {id: string, userName: string};

interface Props {
    Warranty: Warranty[];
    onImageLinkClicked: (serialNo: string, filename: string) => void;
    onClickMakeWarranty: (resultId: string) => void;
}

export default class WarrantyTable extends React.Component<Props, {}> {

    formatTimestamp(timestamp: firestore.Timestamp): string {
        return moment(timestamp.toDate()).format("YYYY年MM月DD日");
    }

    render() {
        return (
            <div style={{overflowX: "auto"}}>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>シリアルナンバー</th>
                            <th>登録年月日</th>
                            <th>保証書ダウンロード</th>
                            <th>保証書作成</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.Warranty.map((result, index) => {
                            return (
                                <tr key={index}>
                                    <td>{result.SerialNo}</td>
                                    <td align="center">
                                        {result.WarrantyFileName !== "" &&
                                            this.formatTimestamp(result.WarrantyStartDate)
                                        }
                                    </td>
                                    <td align="center">
                                        {result.WarrantyFileName !== "" &&
                                            <a href="#" onClick={() => this.props.onImageLinkClicked(result.id,result.WarrantyFileName)}>
                                            保証書ダウンロード
                                            </a>
                                        }
                                    </td>
                                    {result.WarrantyFileName !== "" &&
                                        <td align="center">
                                            保証書作成済み
                                        </td>
                                    }
                                    {result.WarrantyFileName === "" &&
                                        <td align="center">
                                            <Button onClick={() => this.props.onClickMakeWarranty(result.id)}>
                                            保証書作成
                                            </Button>
                                        </td>
                                    }
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </div>
        );
    }
}

